import React from 'react';
import { Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const BrokenStoneEntryPage = () => (
  <>
    <Box sx={{ mb: 2 }}>
      <Button
        component={Link}
        to="/activity-log"
        variant="contained"
        color="primary"
      >
        View Activity Log
      </Button>
    </Box>
    <div>
      <h2>Broken Stone Entry Page</h2>
      <p>This is a placeholder for the Broken Stone Entry functionality.</p>
    </div>
  </>
);

export default BrokenStoneEntryPage; 